import { createContext } from 'react';
import {
  EndorsementServiceFeaturesGetApplicationGroupByUidApplicationGroupDto as ApplicationGroupDto,
  EndorsementServiceFeaturesUpsertApplicationGroupUpsertApplicationGroupDto as UpsertDto,
} from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';

export type ApplicationType = ApplicationGroupDto | UpsertDto | any;

export interface ICurrentApplicationContext {
  application: Loadable<ApplicationType>;
  refresh?: () => void;
  setApplication?: (a: Loadable<ApplicationType>) => void;
}

export const CurrentApplicationContext = createContext<ICurrentApplicationContext>({
  application: {
    loading: false,
    result: undefined,
    error: undefined,
  },
});
